import { ActivatedRouteSnapshot, CanDeactivateFn, RouterStateSnapshot } from '@angular/router';
import { CanComponentDeactivate } from './can-component-deactivate.interface';
import { Observable } from 'rxjs';

export const canDeactivateFormGuard: CanDeactivateFn<CanComponentDeactivate> = (
  component: CanComponentDeactivate,
  _currentRoute: ActivatedRouteSnapshot,
  _currentState: RouterStateSnapshot,
  nextState: RouterStateSnapshot
): Observable<boolean> | Promise<boolean> | boolean => {
  if (nextState?.url?.startsWith('/content-creation/upload')) {
    return true;
  }
  return component.canDeactivate ? component.canDeactivate() : true;
};
